module.exports = "<header class=\"nn-base-module-header nn-base-module-header--{{ theme }}\"><h2 class=nn-base-module-header__title ng-if=title><span ng-if=!url ng-bind-html=title></span> <a ng-if=url ng-href=\"{{ url }}\" rel=\"{{ rel || '' }}\" ng-bind-html=title></a></h2><h3 class=nn-base-module-header__subtitle ng-if=subtitle ng-bind-html=subtitle></h3></header>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-module-header/nn-base-module-header.directive.html
// module id = 957
// module chunks = 0